import type { StatusSolicitacao } from '../../models';

export const STATUS_SOLICITACAO_LABELS: Record<StatusSolicitacao, string> = {
  // Enum continua 'aberta' (não vale a pena migrar dado existente por causa de um rótulo)
  // — só o texto exibido virou "Novo" (ver movimentacaoService.avancarParaEmAndamentoSeNecessario).
  aberta: 'Novo',
  em_andamento: 'Em Andamento',
  concluida: 'Concluída',
  cancelada: 'Cancelada',
  excluida: 'Excluída',
};

export const STATUS_SOLICITACAO_BADGE_CLASS: Record<StatusSolicitacao, string> = {
  aberta: 'bg-yellow-100 text-yellow-800',
  em_andamento: 'bg-blue-100 text-blue-800',
  concluida: 'bg-green-100 text-green-800',
  cancelada: 'bg-gray-100 text-gray-600',
  excluida: 'bg-red-100 text-red-700',
};
